module.exports = __webpack_public_path__ + "static/header-image-04-2d6c4d98f494ed94d62bdec334e3105b.png";